module.exports = __webpack_public_path__ + "static/media/imgn_trigo_espiga.a5300297.png";